
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TeamScorecardService } from '@shared/services/team-scorecard.service';
import { NzUploadFile, UploadFileStatus } from 'ng-zorro-antd/upload';
import { DeveloperService } from "@shared/services/developer.service";
import { DeveloperScorecardService } from "@shared/services/developer-scorecard.service";
import { SortingService } from "@shared/components/modals/export-data-modal/shared-state.service";
import { StorageService } from "@core/services/storage.service";
import { ExecutiveDashboardsService } from "@shared/services/executive-dashboards.service";
import { QWiserService } from "@shared/services/q-wiser.service";


@UntilDestroy()
@Component({
  selector: 'app-export-data-modal',
  templateUrl: './export-data-modal.component.html',
  styleUrls: ['./export-data-modal.component.scss']
})
export class ExportDataModalComponent implements OnInit , OnDestroy {

  @Input() metricType: string;
  @Input() metricName: string;
  @Input() teamId: string;
  @Input() selectedDate: any;
  @Input() to: any;
  @Input() from: any;
  @Input() title?: string
  @Input() showLineChange: boolean;
  @Input() showCount: boolean;
  @Input() filters?: any;
  @Input() sortedBy?: any;
  @Input() sortedOrder?: any;
  @Input() pageIndex?: any;
  @Input() searchByValues?: any;
  @Input() filter?: any;
  @Input() filterQualityGate?: any;
  @Input() filterTeams?: any;
  @Input() searchValue?: any;
  @Input() filterBranches?: any;
  @Input() queryParams?: any;
  intervalId: any;
  isLoadingExport = true;
  sorting: any = {};

  fileList: NzUploadFile[] = [];
  displayFormat = false;

  constructor(private scoreCardService: TeamScorecardService,
              private executiveDashboardsService: ExecutiveDashboardsService,
              private qWiserService: QWiserService,
              public sortingService: SortingService,
              private storageService: StorageService ) {
  }

  ngOnInit(): void {

    if (this.metricType === 'QWISER_ANALYSIS_EXPORT'){
      this.getQualityDataList();
    } else {
      this.getDataList();
    }
    this.sortingService.currentSorting.subscribe(sorting => this.sorting = sorting);
    this.intervalId = setInterval(() =>  this.getDataList(), 5000);
  }

  downloadFile = (file: NzUploadFile) => {
    this.scoreCardService.downloadExportData(file.uid)
      .subscribe(response => {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch && fileNameMatch.length > 1) {
            const fileName = fileNameMatch[1];
            const blob = new Blob([response.body], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
          }
        }
      });
  }

  deleteExportedData = (file: NzUploadFile) => {
    this.scoreCardService.deleteDownloadExportData(file.uid).subscribe(item => {
      this.fileList = this.fileList.filter(fileItem => fileItem.uid !== file.uid);
    });
  }


  private getDataList() {
    if (this.metricType === 'QWISER_ANALYSIS_EXPORT') {
      return
    }
    this.scoreCardService.getExportDataListByTeam(this.teamId, this.metricType).subscribe(response => {
      const tmpList = [];
      response.forEach(item => {
        tmpList.push({
          uid: item.id,
          name: item.fileName,
          status: item.exportStatus === 'IN_PROGRESS' ? 'uploading' : (item.exportStatus === 'COMPLETED' ? 'done' : 'error')
        });
      });
      this.fileList = tmpList;
      this.isLoadingExport = this.fileList.filter(item => item.status === 'uploading').length > 0;
    });
  }

  getQualityDataList() {
    this.qWiserService.getExportDataListByQuality(this.metricType).subscribe(response => {
      const tmpList = [];
      response.forEach(item => {
        tmpList.push({
          uid: item.id,
          name: item.fileName,
          status: item.exportStatus === 'IN_PROGRESS' ? 'uploading' : (item.exportStatus === 'COMPLETED' ? 'done' : 'error')
        });
      });
      this.fileList = tmpList;
      this.isLoadingExport = this.fileList.filter(item => item.status === 'uploading').length > 0;
    });

  }

  exportData() {
    if(this.metricType === 'DORA_AND_IMPACT_METRIC' ||  this.metricType ==='GIT_WORK_TYPE_MEMBER' || this.metricType ==='SUMMARY_METRIC') {
      this.scoreCardService.exportTeam(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.sorting,
        this.searchByValues = null,
        this.storageService.get("showCount") === undefined ? false : this.storageService.get("showCount"),
        this.storageService.get("changeLineCount") === undefined ? false : this.storageService.get("changeLineCount"),
      ).subscribe(item => {
        this.getDataList();
      });
    } else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_SUMMARY_METRIC') {
      this.scoreCardService.exportTeam(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.sorting,
        this.searchByValues,
        this.showCount = undefined,
        this.showLineChange = undefined,
        this.displayFormat,
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_DELIVERY_REPORT_VELOCITY_METRIC') {
      this.scoreCardService.exportDeliveryReport(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.searchByValues
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_DELIVERY_REPORT_PREDICTABILITY_METRIC') {
      this.scoreCardService.exportDeliveryReport(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.searchByValues
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_DELIVERY_REPORT_PRODUCTIVITY_METRIC') {
      this.scoreCardService.exportDeliveryReport(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.searchByValues
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_DELIVERY_REPORT_LEAD_TIME_METRIC') {
      this.scoreCardService.exportDeliveryReport(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.searchByValues,
        this.displayFormat,
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_DELIVERY_REPORT_CYCLE_TIME_METRIC') {
      this.scoreCardService.exportDeliveryReport(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.searchByValues,
        this.displayFormat,
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_BACKLOG_REPORT_METRIC') {
      this.scoreCardService.exportDeliveryReport(
        this.teamId,
        this.selectedDate.fromDate ? this.selectedDate : this.selectedDate.period,
        this.metricType,
        this.searchByValues
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'PROJECT_ANALYTICS_SCRUM_ALLOCATIONS_METRIC') {
      this.scoreCardService.exportAllocationsReport(
        this.teamId,
        this.metricType,
        this.searchByValues
      ).subscribe(item => {
        this.getDataList();
      });
    }
    else if(this.metricType === 'QWISER_ANALYSIS_EXPORT') {
      this.qWiserService.exportQwiserData(
        this.searchValue,
        this.sortedBy,
        this.sortedOrder,
        this.filter,
        this.filterQualityGate,
        this.filterTeams,
        this.filterBranches,
        this.metricType,
        "EXCEL",
      ).subscribe(item => {
        this.getQualityDataList();
      });
    }
    else if (this.metricType === 'TEAM_STATISTICS_REPORT' || this.metricType ==='PULL_REQUEST_REPORT'|| this.metricType ==='DEVELOPER_REPORT' || this.metricType ==='PULL_REQUEST_REVIEW'|| 'REPOSITORY_REPORT') {
      this.executiveDashboardsService.exportData(
        this.teamId,
        this.metricType,
        this.selectedDate.from,
        this.selectedDate.to,
        this.filters,
        this.sortedBy,
        this.sortedOrder,
        this.pageIndex
      ).subscribe(item => {
        this.getDataList();
      });
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}
